import { render, staticRenderFns } from "./CompOpcoesPesquisaErroAjuizamentoProtesto.vue?vue&type=template&id=0da77694&"
import script from "./CompOpcoesPesquisaErroAjuizamentoProtesto.vue?vue&type=script&lang=js&"
export * from "./CompOpcoesPesquisaErroAjuizamentoProtesto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports